export default __webpack_public_path__ + "static/media/image_074_0000-1732265064787.56b320b8.png";